module.exports = __webpack_public_path__ + "media/build/delete-icon-1be1982d.svg";